import React from "react";
import { Helmet } from "react-helmet-async";
import { useRouter } from "./../util/router.js";

function Meta(props) {
  const router = useRouter();
  const title = props.title || "";
  const description = props.description || "";
  
  return (
    <Helmet>
      <title>{`${title}${title ? " | " : ""}Bonuss`}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={router.pathname} />
    </Helmet>
  );
}

export default Meta;
